import "../../styles/compo.scss";
import SvgIcn from "../../data/IconCompo";
import { useState } from "react";

const LogoP = ({
  logo,
  hoverLogo,
  logoTypeEn,
  logoTypeJp,
  className,
  to,
  onClick,
  scale,
  style,
  ...props
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <a
      href={to || "#"}
      className={`logo-box ${className || ""}`}
      style={{ width: scale }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
    >
      <SvgIcn name={isHovered && logo ? hoverLogo : logo} style={style} />

      <div className="logo-type-box">
        <SvgIcn name={logoTypeEn} style={style} />
        <SvgIcn name={logoTypeJp} style={style} />
      </div>
    </a>
  );
};

export default LogoP;
